import { useCallback, useState } from 'react';

import type { WhiteboardNavigationService } from './services/whiteboard-navigation-service';
import type { WhiteboardLockoutState } from './WhiteboardNavigationLockout';

/**
 * Hook to get the desired navigation lockout state set by the navigation service
 */
export const useWhiteboardNavigationLockout = (navigationService: WhiteboardNavigationService) => {
	const [lockoutState, setLockoutState] = useState<WhiteboardLockoutState>({ isLockoutSet: false });

	const lockoutStateHandler = useCallback((newLockoutState: WhiteboardLockoutState) => {
		setLockoutState(newLockoutState);
	}, []);

	navigationService.registerLockoutStateHandler(lockoutStateHandler);

	return lockoutState;
};
